export default function PrivacyPolicy() {
  return (
    <main className="privacy-page">
      <section className="privacy-container">
        <div className="brand-pill">Invexa Finance</div>

        <div className="privacy-card">
          <span className="privacy-badge">LGPD • Segurança • Transparência</span>

          <h1>Política de Privacidade</h1>
          <p className="privacy-updated">Última atualização: Maio de 2026</p>

          <p className="privacy-intro">
            A Invexa Finance respeita sua privacidade e está comprometida em
            proteger os dados dos usuários. Esta política explica como coletamos,
            usamos e protegemos suas informações.
          </p>

          <div className="privacy-section">
            <h2>1. Informações coletadas</h2>
            <p>
              Podemos coletar nome, e-mail, dados financeiros inseridos
              manualmente pelo usuário e informações técnicas necessárias para o
              funcionamento do aplicativo.
            </p>
          </div>

          <div className="privacy-section">
            <h2>2. Como usamos seus dados</h2>
            <p>
              Utilizamos os dados para fornecer as funcionalidades do aplicativo,
              melhorar a experiência, garantir segurança e manter o serviço em
              funcionamento.
            </p>
          </div>

          <div className="privacy-section">
            <h2>3. Segurança</h2>
            <p>
              Adotamos medidas para proteger as informações contra acessos não
              autorizados, alteração, divulgação ou destruição indevida.
            </p>
          </div>

          <div className="privacy-section">
            <h2>4. Compartilhamento</h2>
            <p>
              A Invexa Finance não vende dados pessoais. As informações podem ser
              compartilhadas apenas quando necessário para funcionamento do
              serviço ou por obrigação legal.
            </p>
          </div>

          <div className="privacy-section">
            <h2>5. Direitos do usuário</h2>
            <p>
              O usuário pode solicitar acesso, correção ou exclusão dos seus
              dados entrando em contato pelo e-mail da plataforma.
            </p>
          </div>

          <div className="privacy-contact">
            <strong>Contato oficial</strong>
            <span>invexafinance@outlook.com</span>
          </div>
        </div>
      </section>
    </main>
  );
}
